import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import Seo from "@/components/Seo";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";

export default function FAQs() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/content/faqs").then((r) => setItems(r.data?.data?.items || [])); }, []);
  return (
    <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
      <Seo title="FAQs" description="Frequently asked questions about Crochet Kerry handmade products, delivery and care." />
      <div className="text-center mb-10">
        <p className="text-xs uppercase tracking-luxe text-brand-pink mb-2">Help</p>
        <h1 className="font-serif-display text-4xl sm:text-5xl">Frequently asked questions</h1>
      </div>
      <Accordion type="single" collapsible className="w-full" data-testid="faqs">
        {items.map((it, i) => (
          <AccordionItem key={i} value={`q${i}`}>
            <AccordionTrigger className="text-left font-serif-display text-lg">{it.q}</AccordionTrigger>
            <AccordionContent className="text-muted-foreground leading-relaxed">{it.a}</AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>
    </div>
  );
}
